<!-- ---------------------------------------New App Content Based On Theme----------------------------------------------------------------      -->
<div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-xxl" *ngIf="suvDetails">
        <div class="card mb-5 mb-xxl-8">
            <div class="card-body pt-9 pb-0" [ngClass]="{'switchUserContainer':surveyService.switchUserAccess && surveyService.redirectFromCompletion}">
                <div *ngIf="surveyService.redirectFromCompletion" class="d-flex mb-2">
                    <div class="d-flex align-items-center ">
                        <div class="fs-5 fw-normal text-muted">
                            {{'Pid- '}}
                        </div>
                        <div class="fs-6 text-dark fw-normal">
                            {{surveyService.getSurveyDetailsPid()}}
                        </div>
                    </div>
                    <div class="borderPid">

                    </div>
                    <div class="d-flex align-items-center ms-2">
                        <div class="fs-5 fw-normal text-muted">
                            {{'Cags- '}}
                        </div>

                        <div class="fs-6 text-dark fw-normal">
                            {{surveyService.getCagsDeatils()}}
                        </div>
                    </div>
                </div>


                <div class="d-flex flex-wrap flex-sm-nowrap mb-6" [ngClass]="{'switchUserCard':surveyService.switchUserAccess && surveyService.redirectFromCompletion}">
                    <div class="d-flex flex-center flex-shrink-0 bg-light rounded w-100px h-100px w-lg-150px h-lg-150px me-7 mb-4">
                        <div class="Badge-Div">
                            <!-- <div class="Badge-Circle-cont">{{GetFirstLetter(suvDetails['name'])}}</div> -->
                            <!-- <div class="Badge-Circle-cont">{{suvDetails['name'][0] | uppercase}}</div> -->
                            <div *ngIf="suvDetails['name']" class="Badge-Circle-cont">{{suvDetails['name'][0] | uppercase}}</div>

                        </div>
                    </div>
                    <div class="flex-grow-1 dashboard-content">
                        <div class="d-flex justify-content-between align-items-start flex-wrap mb-2">
                            <div class="Details-Component">
                                <div class="d-flex mb-1 survey-name-div">
                                    <div>
                                        <a href="#" class="text-gray-800 text-hover-primary fs-2 fw-bold me-3">{{suvDetails.name}}</a>
                                    </div>
                                </div>
                             
                                <div style="display: flex;">
                                    <div *ngIf="surveyService.surveyDetails.test_link && surveyService.surveyDetails.test_link != '' && surveyService.accessRoles.survey && surveyService.accessRoles.survey.test_link">
                                        <button  class="btn btn-sm btn-primary me-3" (click)="getTestLinkDetails(suvDetails.test_link)">Test Link</button>
                                    </div>
                                    <div *ngIf="surveyService.surveyDetails.link && surveyService.surveyDetails.link != '' && surveyService.surveyDetails.test_link != '' && surveyService.accessRoles.survey && surveyService.accessRoles.survey.get_link">
                                        <button class="btn btn-sm btn-primary me-3" (click)="getLinkDetails(0)">Get Link</button>
                                    </div>
                                  
                                    <div *ngIf="surveyService.showMultipleLinkAccess || (surveyService.accessRoles.survey && surveyService.accessRoles.survey.multiple_link)">
                                        <button class="btn btn-sm btn-bg-light btn-active-color-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                                            Get Multiple Links
                                        </button>
                                        <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-250px py-3" data-kt-menu="true" >
                                            <div *ngIf="surveyService.surveyDetails.link && surveyService.surveyDetails.link != ''">
                                                <div class="menu-item px-3 d-flex justify-content-between align-items-center">
                                                    <div class="menu-content text-dark pb-2 px-3 fs-6">Link Count</div>
                                                    <input class="form-control w-100px" type="text" style="height: 30px;" [(ngModel)]="surveyService.defaultSurveyGetLink"/>
                                                </div>
                                                <div class="menu-item m-2">
                                                    <button class="menu-link px-3 btn btn-primary btn-sm text-white ms-3" (click)="getLinkDetails(1)">Generate</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
									

                                    <div *ngIf="surveyService.accessRoles.survey && surveyService.accessRoles.survey.switch_container" class="mx-3 ">
                                        <!-- <div *ngIf="surveyService.redirectFromInventory && surveyService.copy_containers_arr.length > 0">
                                            <button class="btn btn-sm btn-bg-light btn-active-color-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                                                {{surveyService.selected_container.container_name | titlecase}}
                                                ({{surveyService.selected_container.status}})
                                            </button>
                                            <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px py-3" data-kt-menu="true" >
                                                <div class="details-Container-Div">
                                                    <input class="form-control" type="search" />
                                                </div>
                                                <div>
                                                    <ng-container *ngFor="let Item of surveyService.containers_arr;let i = index">
                                                        <div class="text-dark fw-bold fs-7 showAllContainers-div"
                                                        (mouseover)="changeContainerBgColor(i)"
                                                        (mouseout)="changeContainerBgColor(-1)"
                                                        (click)="switchContainerCall(Item)"
                                                        [ngClass]="{'HoveringDiv':i===containerHoverIndex}"
                                                        >
                                                            {{Item.container_name | titlecase}}({{Item.status}})
                                                        </div>
    
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div> -->

                                        <div ngbDropdown class="d-inline-block" *ngIf="surveyService.redirectFromInventory && surveyService.copy_containers_arr.length > 0"  #myDrop="ngbDropdown">
                                            <button class="btn btn-sm btn-bg-light btn-active-color-primary" id="dropdownBasic2" ngbDropdownToggle>
                                                {{surveyService.selected_container.container_name | titlecase}}
                                                ({{surveyService.selected_container.status}})
                                            </button>
                                            <div  ngbDropdownMenu aria-labelledby="dropdownBasic2">
                                                <div class="details-Container-Div">
                                                    <input class="form-control" type="search" />
                                                </div>
                                                <div class="container_Show">
                                                    <ng-container *ngFor="let Item of surveyService.containers_arr;let i = index">
                                                        <div class="text-dark fw-bold fs-7 showAllContainers-div"
                                                        (mouseover)="changeContainerBgColor(i)"
                                                        (mouseout)="changeContainerBgColor(-1)"
                                                        (click)="switchContainerCall(Item);$event.stopPropagation(); myDrop.close()"
                                                        [ngClass]="{'HoveringDiv':i===containerHoverIndex}"
                                                        >
                                                            {{Item.container_name | titlecase}}({{Item.status}})
                                                        </div>
    
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>


                                        <div *ngIf="surveyService.redirectFromCompletion">
                                            <button class="btn btn-sm btn-bg-light btn-active-color-primary">
                                                {{surveyService.selected_container.container_name | titlecase}}
                                                ({{surveyService.selected_container.status}})
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                      
                        <div class="d-flex flex-wrap justify-content-start">
                            <div class="d-flex flex-wrap">
                                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                    <div class="d-flex align-items-center">
                                        <div class="fs-4 fw-bold">{{suvDetails.start || "-"}}</div>
                                    </div>
                                    <div class="fw-semibold fs-6 text-gray-400">Start Date</div>
                                </div>
                                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                    <div class="d-flex align-items-center">
                                        <div class="fs-4 fw-bold">{{suvDetails.complete || "-"}}</div>
                                    </div>
                                    <div class="fw-semibold fs-6 text-gray-400">End Date</div>
                                </div>

                                <!-- <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                    <div class="d-flex align-items-center">
                                        <div class="fs-4 fw-bold">{{suvDetails.crownit_sample_size}}</div>                                        
                                    </div>
                                    <div class="fw-semibold fs-6 text-gray-400">Exculsive Sample Size</div>
                                </div>

                                
                                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                    <div class="d-flex align-items-center">
                                        <div class="fs-4 fw-bold">{{suvDetails.total_sample_size}}</div>
                                    </div>
                                    <div class="fw-semibold fs-6 text-gray-400">Shared Sample Size</div>
                                </div> -->


                                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                    <div class="d-flex align-items-center">
                                        <div class="fs-4 fw-bold">{{suvDetails.completes}}</div>                                        
                                    </div>
                                    <div class="fw-semibold fs-6 text-gray-400">Completes</div>
                                </div>

                                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                    <div class="d-flex align-items-center">
                                        <div class="fs-4 fw-bold">{{suvDetails.remaining_exclusive}}</div>                                        
                                    </div>
                                    <div class="fw-semibold fs-6 text-gray-400">Remaining Exclusive</div>
                                </div>

                                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                    <div class="d-flex align-items-center">
                                        <div class="fs-4 fw-bold">{{suvDetails.remaining_shared}}</div>                                        
                                    </div>
                                    <div class="fw-semibold fs-6 text-gray-400">Remaining Shared</div>
                                </div>

                           

                            
                                <!-- <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                    <div class="d-flex align-items-center">
                                        <div class="fs-4 fw-bold">&#8377; 2050</div>
                                    </div>
                                    <div class="fw-semibold fs-6 text-gray-400">Revenue Generated</div>
                                </div>
                                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                    <div class="d-flex align-items-center">
                                        <div class="fs-4 fw-bold">&#8377; 3050</div>
                                    </div>
                                    <div class="fw-semibold fs-6 text-gray-400"> Potential earnings</div>
                                </div> -->
                              
                            </div>
                           
                        </div>
                    </div>
                </div>
                <div class="separator"></div>
                <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
                    <li class="nav-item cursor-pointer" *ngIf="surveyService.accessRoles.survey && surveyService.accessRoles.survey.details && surveyService.accessRoles.survey.details.view">
                        <a class="nav-link text-dark text-active-primary py-5 ms-6" (click)="detailsRouterChange()">Details</a>
                    </li>
                    <li class="nav-item cursor-pointer" *ngIf="surveyService.accessRoles.survey && surveyService.accessRoles.survey.target_group && surveyService.accessRoles.survey.target_group.view">
                        <a class="nav-link text-dark text-active-primary py-5 mx-6" (click)="tgQuotaRouterChange()">Target Group</a>
                    </li>
                    <li class="nav-item cursor-pointer" *ngIf="surveyService.accessRoles.survey && surveyService.accessRoles.survey.quota_details && surveyService.accessRoles.survey.quota_details.view">
                        <a class="nav-link text-dark text-active-primary py-5 mx-6 active" (click)="quotaRouterChange()">Quota Details</a>
                    </li>
                    <!-- <li class="nav-item cursor-pointer" *ngIf="surveyService.oprationsAccessRules.showOprations">
                        <a class="nav-link text-dark text-active-primary py-5 mx-6" (click)="uploadRejectionRouterChange()">Operations</a>
                    </li> -->
                </ul>
            </div>
        </div>
        <div class="card">
            <div class="card-header">
                <div class="card-title fs-3 fw-bold">Survey Quota Details </div>
                <div class="card-radio-button">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="Shared" value="shared" [(ngModel)]="surveyService.quotaType" (change)="onQuoteTypeChange()">
                        <label class="form-check-label fw-bold text-dark mx-2" for="Shared">
                          Shared 
                        </label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="Exclusive" value="exclusive" [(ngModel)]="surveyService.quotaType" (change)="onQuoteTypeChange()">
                        <label class="form-check-label fw-bold text-dark mx-2" for="Exclusive">
                            Exclusive
                        </label>
                    </div>

                </div>
            
            </div>

           
            <!-- <div class="table-Quota">
                <table class="table table-row-bordered table-Container " *ngIf="surveyService.QuotaDetails.length > 0">
                    <thead>
                        <tr>
                            <th class="col-3 fs-5 fw-bold">SL No</th>
                            <th class="col-3 fs-5 fw-bold">Name</th>
                            <th class="col-3 fs-5 fw-bold">Total</th>
                            <th class="col-3 fs-5 fw-bold">Completes</th>
                        </tr>
                    </thead>
                    <tbody >
                        <tr *ngFor="let Item of surveyService.QuotaDetails; let ind=index">
                            <th class="col-3 text-muted fs-5 fw-bold">{{ind+1}}</th>
                            <th class="col-3 text-muted fs-5 fw-bold">{{Item['name']}}</th>
                            <th class="col-3 text-muted fs-5 fw-bold">{{Item['total']}}</th>
                            <th class="col-3 text-muted fs-5 fw-bold">{{Item['Completes']}}</th>
                        </tr>
                    </tbody>
                </table>
            </div> -->
            <div class="table-container TABLE-CONT">
                <div class="card-body bg-white px-5 py-2">
                  <div>
                    <table class="table-responsive table table-row-bordered align-left">
                      <thead>
                         <tr class="fw-bold fs-5 py-3">
                          <th>SL No.</th>
                          <th>Name </th>
                          <!-- <th>Total</th> -->
                          <th>Remaining</th>
                          <th>Completes</th>
                          <th>In Progress</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let survey of quotaDetails; let i = index;">
                          <tr class="text-start py-3">
                            <td>
                              <span class="text-muted fw-bold fs-5"
                                >{{ i+1 }}</span
                              >
                            </td>
                            <td>
                              <div class="d-flex align-items-center">
                                <div class="d-flex justify-content-start flex-column fw-bold fs-5">
                                  {{ survey['name'] }}
                                </div>
                              </div>
                            </td>
                            <!-- <td>
                              <span class="text-muted fw-bold text-muted d-block fs-5"
                                >{{ survey['total'] }}</span
                              >
                            </td> -->

                            <td>
                                <span class="text-muted fw-bold text-muted d-block fs-5"
                                  >{{ survey['remaining'] || 0 }}
                                  </span>
                            </td>



                            <td>
                              <span class="text-muted fw-bold text-muted d-block fs-5">{{ survey['completes'] || 0}}</span>
                            </td>
                            <td>
                                <span class="text-muted fw-bold text-muted d-block fs-5">{{ survey['in_progress'] || 0}}</span>
                            </td>
                            <td>
                                <img #ArrowUp *ngIf="CheckArrowDirection(i)" (click)="InnerSubTableOpen(i)" style="width:18px; cursor: pointer;" src="../../../../assets/media/icons/arrowup.png" />
                                <img #ArrowDown *ngIf="!CheckArrowDirection(i)" (click)="InnerSubTableOpen(i)" style="width:18px; cursor: pointer;" src="../../../../assets/media/icons/arrowdown.png" />
                            </td>
                          </tr>
                          <tr *ngIf="CheckSubQuotaOpen(i)">
                            <div class="fw-bold fs-5 text-dark" style="margin-bottom: -10px;">Quota logic is like this</div>
                            <ng-container *ngFor="let Item of survey['details']; let i=index">
                                <div class="Logical-Operator">
                                    <div class="fw-bold text-dark fs-5  me-4">{{i+1}}</div>
                                    <div class="text-muted fw-bold my-3 fs-5">{{Item['qualification'] + ' ' + Item['operand'] + " " + Item['value'] | uppercase }}</div>
                                </div>
                            </ng-container>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            <!-- <form id="kt_project_settings_form" class="form">
                <div class="card-body p-9 Details-Container">
                    <div class="row d-flex justify-content-between mb-4">
                        <div class="col-3 fs-6 text-muted fw-bold Audience-Div">Audience</div>
                        <div class="col-3 fs-6 text-muted fw-bold">Required</div>
                        <div class="col-3 fs-6 text-muted fw-bold">Completed</div>
                    </div>
                    <ng-container *ngFor="let surveyDetails of quotas;">
                        <div class="row mb-8 me-2 d-flex justify-content-between">
                            <div class="col-xl-3 fv-row">
                                <input type="text" class="form-control form-control-solid" name="survey_name" [(value)]="surveyDetails['name']" />
                                <input type="text" class="form-control form-control-solid" [name]="surveyDetails['key']" [(ngModel)]="surveyService.surveyReport['surveyDetails['key']']" />
                            </div>
                            <div class="col-xl-3 fv-row">
                                <input type="text" class="form-control form-control-solid" name="survey_name" [(value)]="surveyDetails['required']" />
                                <input type="text" class="form-control form-control-solid" [name]="surveyDetails['key']" [(ngModel)]="surveyService.surveyReport['surveyDetails['key']']" />
                            </div>
                            <div class="col-xl-3 completed-survey">
                                <div class="fs-6 fw-semibold mt-2 mb-3">{{surveyDetails['completed']}}</div>
                            </div>
                        </div>
                        
                    </ng-container>
                </div>
                <div class="card-footer d-flex justify-content-end py-6 px-9">
                    <button type="reset" class="btn btn-light btn-active-light-primary me-2">Discard</button>
                    <button type="submit" class="btn btn-primary" id="kt_project_settings_submit">Save Changes</button>
                </div>
            </form> -->
            
        </div>
        
    </div>
</div>